let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import styled, { css } from 'styled-components';
import { styledIf, colors } from '@ovpn-ui/styles';
import Box from '../Box';
import { shadows } from '../styles';
export const Container = styled(Box)(_t || (_t = _`
    position: relative;

    display: inline-flex;
    flex-direction: ${0};
    gap: 8px;

    cursor: pointer;

    ${0}
`), ({
  $direction
}) => $direction === 'ltr' ? 'row' : 'row-reverse', styledIf('$disabled')(_t2 || (_t2 = _`
        pointer-events: none;
    `)));
const sizeDefault = css(_t3 || (_t3 = _`
    width: 20px;
    height: 20px;
    &:before {
        border-radius: ${0};
    }
`), ({
  rounded: isCircular
}) => isCircular ? '20px' : '4px');
const sizeSmall = css(_t4 || (_t4 = _`
    width: 16px;
    height: 16px;

    &:before {
        border-radius: ${0};
    }
`), ({
  rounded: isCircular
}) => isCircular ? '16px' : '4px');
const checkedStyle = css(_t5 || (_t5 = _`
    ${0}
`), ({
  checked,
  indeterminate
}) => (checked || indeterminate) && `.ovpn-checkbox-input.is-checked + &,
        .ovpn-checkbox-input.is-indeterminate + & {
            &:before {
                background-color: ${colors.primaryBase};
                border-color: ${colors.primaryBase};
            }
        }

    .ovpn-checkbox-input.is-checked:hover + &,
    .ovpn-checkbox-input.is-indeterminate:hover + & {
        &:before {
            background-color: ${colors.primaryBaseHover};
            border-color: ${colors.primaryBaseHover};
        }
    }

    .ovpn-checkbox-input.is-checked:focus + &,
    .ovpn-checkbox-input.is-indeterminate:focus + & {
        &:before {
            background-color: ${colors.primaryBase};
            border-color: ${colors.primaryBaseActive};
        }
    }`);
const indeterminateStyle = css(_t6 || (_t6 = _`
    ${0}
`), ({
  indeterminate
}) => indeterminate && checkedStyle);
const disabledStyle = css(_t7 || (_t7 = _`
    .ovpn-checkbox-input.is-disabled + &,
    .ovpn-checkbox-input.is-disabled.is-indeterminate + &,
    .ovpn-checkbox-input.is-disabled.is-checked + & {
        &:before {
            ${0}
        }
        svg {
            color: ${0};
        }
    }
`), ({
  disabled
}) => disabled && css(_t8 || (_t8 = _`
                    background-color: ${0};
                    border-color: ${0};
                    box-shadow: none;
                `), colors.neutralLight, colors.neutralBorder), colors.neutralBorder);
export const Appearance = styled.span(_t9 || (_t9 = _`
    position: relative;

    display: inline-block;
    flex-shrink: 0;

    width: 100%;
    height: 100%;

    color: ${0};

    ${0};
    ${0}

    &:before {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        background-color: ${0};

        border: 1px solid;
        border-color: ${0};

        box-shadow: ${0};

        content: '';
    }

    svg {
        position: absolute;
        top: 50%;
        left: 50%;

        color: ${0};

        transform: translate(-50%, -50%);

        fill: none;
    }

    .ovpn-checkbox-input:hover + & {
        &:before {
            background-color: ${0};
        }
    }

    .ovpn-checkbox-input:focus + & {
        &:before {
            background-color: ${0};
            border-color: ${0};
            box-shadow: ${0};
        }
    }

    ${0};
    ${0};
    ${0};
`), ({
  disabled
}) => disabled ? colors.neutralBorder : colors.white, ({
  small
}) => small ? sizeSmall : sizeDefault, ({
  withContent
}) => withContent && `margin-top: 2px;`, colors.neutralBg, colors.primaryBase, ({
  small
}) => small ? shadows.xs : shadows.sm, colors.neutralWhite, colors.neutralBgHover, colors.neutralBgHover, colors.primaryBase, shadows.focusedBlue, checkedStyle, indeterminateStyle, disabledStyle);
export const ContentWrapper = styled.div(_t10 || (_t10 = _`
    display: flex;
    flex-direction: column;
`));